import React from 'react';

import { Category } from '@interfaces/ti50';
import { parameterize } from '@utils/formatting';

import CategoryHeaderImage from './CategoryHeaderImage';

interface HeaderCategoryListProps {
  activeCategories: Category[];
  hasHoverImage?: boolean;
  projectSlug: string;
}

const HeaderCategoryList = ({
  activeCategories,
  hasHoverImage = true,
  projectSlug,
}: HeaderCategoryListProps) => {
  return (
    <>
      <h2 className="mt-64 border-0 border-b border-solid border-current font-suisse-screen text-[18px] font-normal">
        Categories
      </h2>
      <ul className="category-container my-32 grid grid-cols-2 p-0 xs:grid-cols-3 xs:gap-20 sm:my-48 sm:grid-cols-4">
        {activeCategories.map(({ category, image_name }) => {
          return (
            <li key={category} className="category flex flex-col items-center">
              <a
                className="anchor-link img-container flex flex-col items-center justify-center"
                href={`#${parameterize(category)}`}
              >
                <CategoryHeaderImage
                  hasHoverImage={hasHoverImage}
                  imageName={image_name}
                  projectSlug={projectSlug}
                />
              </a>
              <div className="category-name">{category}</div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default HeaderCategoryList;
